import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  image: '',
  score: '',
  description_vi: '',
  description_en: '',
  description_jp: '',
  status: '',
  search: '',
};
export const reviewItemSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = reviewItemSlice.actions;

export default reviewItemSlice.reducer;
